import clsx from "clsx";

type BlanketProps = {
	children?: React.ReactNode;
	className?: string;
	width?: "sm" | "md" | "lg" | "xl";
};

type BlanketImageProps = {
	src?: string;
	icon?: React.ReactNode;
};

type BlanketInfoProps = {
	children?: React.ReactNode;
	title?: string;
	message?: string;
	action?: React.ReactNode | { onClick: () => void };
};

export const Blanket = ({
	children,
	className,
	width = "xl",
}: BlanketProps) => {
	return (
		<div
			className={clsx("flex flex-col w-full mx-auto p-12 gap-4", className, {
				"max-w-[960px]": width === "xl",
				"max-w-[720px]": width === "lg",
				"max-w-[560px]": width === "md",
				"max-w-[420px]": width === "sm",
			})}
		>
			{children}
		</div>
	);
};

export const BlanketImage = ({ src, icon }: BlanketImageProps) => {
	return (
		<>
			{src && (
				<div className="flex flex-col w-full">
					<img className="block w-full h-auto" src={src} alt="" />
				</div>
			)}

			{icon && (
				<div className="inline-flex justify-center items-center self-center w-[100px] h-[100px] p-2 rounded-full border border-slate-100 ">
					<div className="inline-flex justify-center items-center self-center w-full h-full p-2 rounded-full border border-slate-200/70">
						<div className="inline-flex justify-center items-center self-center w-full h-full p-2 rounded-full border border-slate-200">
							<div className="inline-flex justify-center items-center self-center w-full h-full rounded-full bg-slate-200/70 text-gray-800">
								{icon}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export const BlanketInfo = ({
	children,
	title,
	message,
	action,
}: BlanketInfoProps) => {
	return (
		<div className="flex flex-col w-full">
			{title || message || action ? (
				<div className="flex flex-col w-full">
					{title && (
						<span className="text-center font-bold text-base text-foreground-dark">
							{title}
						</span>
					)}
					{message && (
						<span className="mt-1 text-center text-base text-foreground/70">
							{message}
						</span>
					)}
					{action && (
						<div className="inline-flex self-center flex-row justify-center w-full mt-4">
							{action}
						</div>
					)}
				</div>
			) : (
				children
			)}
		</div>
	);
};
